import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-phone-mask-type',
  templateUrl: './phone-mask-type.component.html',
  styleUrls: ['./phone-mask-type.component.css']
})
export class PhoneMaskTypeComponent extends FieldType {}
